import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { ApiService } from './services/api.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { SettingService } from './services/settings.service';

import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { InputFormlyFieldComponent } from './formly/input-formly-field.component';
import { InputWrapperComponent } from './formly/inputWrapper.component';


const routes: Routes = [{path: '', component: AppComponent}];

@NgModule({
  declarations: [
    AppComponent,
    InputFormlyFieldComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormlyModule.forRoot({
      types: [
        { name: 'input', component: InputFormlyFieldComponent, wrappers: ['panel'] },
      ],
      wrappers: [
        { name: 'panel', component: InputWrapperComponent },
      ],
    }),
    RouterModule.forRoot(routes)
  ],
  providers: [
    ApiService,
    SettingService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
